import { Controller } from "@hotwired/stimulus"

// Turbo owns requests/rendering. Serialize autosaves so the newest rate wins.
export default class extends Controller {
  static targets = ["content", "loading", "rateForm", "continue", "status", "rateComparison"]

  loading() {
    if (this.hasContentTarget) this.contentTarget.hidden = true
    if (this.hasLoadingTarget) this.loadingTarget.hidden = false
  }

  loaded() {
    if (this.hasContentTarget) this.contentTarget.hidden = false
    if (this.hasLoadingTarget) this.loadingTarget.hidden = true
  }

  changed() {
    if (!this.dirty && !this.saving && !this.lastSaveFailed && this.rateMatchesSaved()) return
    this.dirty = true
    this.rateComparisonTargets.forEach(banner => { banner.hidden = true })
    this.lockContinue()
    this.statusTarget.textContent = "Checking rate…"
    clearTimeout(this.timer)
    this.timer = setTimeout(() => this.save(), 450)
  }

  saveNow(event) {
    event.preventDefault()
    clearTimeout(this.timer)
    this.save()
  }

  save() {
    if (this.saving || !this.dirty) return
    this.dirty = false
    this.saving = true
    this.submittedAmount = this.currentAmount()
    this.rateFormTarget.requestSubmit()
  }

  saved(event) {
    this.saving = false
    this.lastSaveFailed = !event.detail.success
    // Turbo may finish the request before its stream updates the footer.
    if (event.detail.success) this.savedAmount = this.submittedAmount
    if (event.detail.success && this.rateMatchesSaved()) {
      this.dirty = false
      clearTimeout(this.timer)
    }
    if (this.dirty) {
      this.lockContinue()
      this.save()
    } else {
      this.statusTarget.textContent = event.detail.success ? "Rate checked" : "Could not save this rate. Check the amount and try again."
      if (!event.detail.success) this.lockContinue()
      else {
        this.refreshContinue()
        this.rateComparisonTargets.forEach(banner => this.rateComparisonTargetConnected(banner))
      }
    }
  }

  continueTargetConnected() {
    this.refreshContinue()
  }

  rateComparisonTargetConnected(banner) {
    if (!this.hasRateFormTarget) return
    banner.hidden = this.currentAmount() !== Number(banner.dataset.savedRate)
  }

  currentAmount() {
    return Number(this.rateFormTarget.querySelector('[name="single_case_agreement[agreed_amount]"]').value.replace(/[$,\s]/g, ""))
  }

  rateMatchesSaved() {
    const amount = this.currentAmount()
    const saved = this.savedAmount ?? Number(this.continueTargets[0]?.dataset.savedRate)
    return Number.isFinite(amount) && amount > 0 && amount === saved
  }

  refreshContinue() {
    const amount = this.hasRateFormTarget ? this.rateFormTarget.querySelector('[name="single_case_agreement[agreed_amount]"]').value : ""
    const cents = value => Math.round(Number(String(value).replace(/[$,\s]/g, "")) * 100)
    this.continueTargets.forEach(button => {
      button.disabled = this.dirty || this.saving || button.dataset.rateApproved !== "true" || cents(amount) !== cents(button.dataset.savedRate)
    })
  }

  lockContinue() { this.continueTargets.forEach(button => { button.disabled = true }) }
  disconnect() { clearTimeout(this.timer) }
}
